module.exports = __webpack_public_path__ + "static/media/password_1000.87a076f9.ico";